import React, { useState, useEffect } from "react";
import Home from "./pages/Home";
import Servizi from "./pages/Servizi";
import Prenotazioni from "./pages/Prenotazioni";
import CupGvm from "./pages/CupGvm";

function App() {
  const [pagina, setPagina] = useState(
    localStorage.getItem("pagina") || "home"
  );

  useEffect(() => {
    localStorage.setItem("pagina", pagina);
  }, [pagina]);

  const renderPagina = () => {
    switch (pagina) {
      case "home":
        return <Home setPagina={setPagina} />;
      case "servizi":
        return <Servizi />;
      case "prenotazioni":
        return <Prenotazioni />;
      case "cup":
        return <CupGvm />;
      default:
        return <Home setPagina={setPagina} />;
    }
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        position: "relative",
        minHeight: "100vh",
        paddingBottom: "90px"
      }}
    >
      {/* Titolo sopra */}
      <h2 style={{ textAlign: "center", paddingTop: "30px", color: "#333" }}>
        {pagina === "home" && "Benvenuto al Medicajato Center"}
        {pagina === "servizi" && "I Nostri Servizi"}
        {pagina === "prenotazioni" && "Prenota una Visita"}
        {pagina === "cup" && "CUP Maria Eleonora Hospital"}
      </h2>

      {/* Contenuto */}
      <div>{renderPagina()}</div>

      {/* NAV BAR BASSA */}
      <nav
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          textAlign: "center",
          padding: "12px",
          backgroundColor: "#f8f9fa",
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
          zIndex: 10
        }}
      >
        <button
          onClick={() => setPagina("home")}
          style={navButton(pagina === "home")}
        >
          Home
        </button>

        <button
          onClick={() => setPagina("servizi")}
          style={navButton(pagina === "servizi")}
        >
          Servizi
        </button>

        <button
          onClick={() => setPagina("prenotazioni")}
          style={navButton(pagina === "prenotazioni")}
        >
          Prenotazioni
        </button>

        <button
          onClick={() => setPagina("cup")}
          style={navButton(pagina === "cup")}
        >
          CUP
        </button>
      </nav>
    </div>
  );
}

/* STILE BOTTONI NAV */
const navButton = (attiva) => ({
  margin: "6px",
  padding: "12px 22px",
  cursor: "pointer",
  borderRadius: "25px",
  border: "none",
  fontSize: "15px",
  backgroundColor: attiva ? "#8b0000" : "#007bff",
  color: "#fff",
  boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
  transition: "all 0.3s ease",
  outline: "none",
  ...(attiva && { transform: "scale(1.05)" })
});

export default App;
